import { useLocation, NavLink } from "react-router-dom";
import { LocaleContext } from "../contexts/LocaleContext";
import { useContext, useEffect, useState } from "react";

const Sidebar = () => {
  const { t } = useContext(LocaleContext);
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  // Define sidebar items in a single configuration array for easy maintenance
  const menuItems = [
    { path: "/dashboard", icon: "fas fa-home", label: "home" },
    { path: "/trips", icon: "fas fa-map-marker-alt", label: "trips" },
    // { path: "/trip-videos", icon: "fas fa-video", label: "tripVideos" },
    { path: "/providers", icon: "fas fa-suitcase", label: "serviceProviders" },
    { path: "/connected-users", icon: "fas fa-users", label: "connectedUsers" },
    { path: "/users-activity", icon: "fas fa-chart-line", label: "usersActivity" },
    { path: "/customers", icon: "fas fa-users", label: "customers" },
    { path: "/block-users", icon: "fas fa-ban", label: "blockUsers" },
    { path: "/bookings", icon: "fas fa-calendar-alt", label: "bookings" },
    // { path: "/chats", icon: "fas fa-comments", label: "chats" }, // old chat module — kept for later reference, hidden from sidebar
    { path: "/chat-messages", icon: "fas fa-comments", label: "chats" },
    { path: "/categories", icon: "fas fa-th", label: "categories" },
    { path: "/banners", icon: "fas fa-images", label: "banners" },
    { path: "/notifications", icon: "fas fa-bell", label: "notifications" },
    { path: "/transactions", icon: "fas fa-sack-dollar", label: "transactions" },
    // { path: "/cities", icon: "fas fa-city", label: "cities" },
    { path: "/countries", icon: "fas fa-globe", label: "countries" },
    { path: "/auth-failures", icon: "fas fa-shield-halved", label: "authFailureMonitoring" },
    { path: "/payment-methods", icon: "fas fa-credit-card", label: "paymentMethods" },
  ];
  useEffect(() => {
    const path = location.pathname;
    let idx = menuItems.findIndex((item) => item.path === path);
    if (idx === -1) {
      const detailToParent = {
        "notification-details": "/notifications",
        "provider-details": "/providers",
        "customer-details": "/customers",
        "trip-details": "/trips",
        "booking-details": "/bookings",
        "city-details": "/cities",
        "payment-method-form": "/payment-methods",
      };
      const segment = path.split("/")[1];
      const parentPath = detailToParent[segment];
      if (parentPath) {
        idx = menuItems.findIndex((item) => item.path === parentPath);
      }
    }
    if (idx !== -1) {
      setActiveIndex(idx);
      sessionStorage.setItem("activeIndex", idx);
    } else {
      const stored = sessionStorage.getItem("activeIndex");
      if (stored) setActiveIndex(parseInt(stored));
    }
  }, [location.pathname]);
  /**
   * Dynamically determines the class based on proximity to the active route.
   * This replaces the manual 'handelIndex' state logic.
   */
  const handelIndex = (i) => {
    setActiveIndex(i);
    sessionStorage.setItem("activeIndex", i);
  };
  const getClassName = (index) => {
    if (index === activeIndex) return "selected";
    if (index === activeIndex - 1) return "selected-prev";
    if (index === activeIndex + 1) return "selected-next";
    return "";
  };

  return (
    <aside className={activeIndex === 0 ? "my-aside" : ""}>
      <label className="fas fa-times" htmlFor="aside-toggle"></label>
      <ul>
        <li className="">
          <a
            href="#"
            className={activeIndex === 0 ? "selected-prev hidden" : "hidden"}
          >
            <i className="fas fa-users"></i> hidden
          </a>
        </li>
        {menuItems.map((item, index) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={getClassName(index)}
              onClick={() => handelIndex(index)}
            >
              <i className={item.icon}></i> {t(item.label)}
            </NavLink>
          </li>
        ))}
        <li className="">
          <a
            href="#"
            className={
              activeIndex === menuItems.length - 1
                ? "selected-next hidden"
                : "hidden"
            }
          >
            <i className="fas fa-users"></i> hidden
          </a>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
